<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div v-if="varComp"></div>
    <component v-bind="$attrs" :is="varComp" class="fill-current" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useIcons } from '@/composables/useIcons'

const props = defineProps({
    name: {
        type: String,
        required: true
    }
})

const varComp = computed(() => {
    return useIcons(props.name).icon.value
})
</script>
